import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import ValidatesFormWith from '../../../utils/ValidatesFormWith';
import validationSchema from './validation';
import Interests from '../../../utils/Interests';
import WYSIWYG from '../../../components/WYSIWYG';
import Input from '../../../components/Input';

class MassiveMailerForm extends PureComponent {
  onChangeInterest = (e, props) => {
    const { name, checked } = e.target;
    let { interests } = props.values;

    if (!interests) {
      interests = [];
    }

    interests = (interests.slice() || []);

    const index = interests.indexOf(name);

    if (checked && index === -1) {
      interests.push(name);
    } else if (index > -1) {
      interests.splice(index, 1);
    }

    props.setFieldValue('interests', interests);
    props.setFieldTouched('interests', true);
  };

  process = (values, actions) => {
    const content = draftToHtml(convertToRaw(values.content.getCurrentContent()));

    this.props.onSubmit({
      content,
      subject: values.subject,
      interests: values.interests,
    });
    actions.resetForm({
      subject: '',
      interests: [],
      content: EditorState.createEmpty(),
    });
  };

  render() {
    return (
      <Formik
        enableReinitialize
        initialValues={{
          interests: [],
          subject: '',
          content: EditorState.createEmpty(),
        }}
        onSubmit={this.process}
        validate={ValidatesFormWith(validationSchema)}
        validateOnChange={false}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            <div className="search-contents-sidebar">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading" style={{ marginBottom: 0 }}>Intereses</h2>

                  <div className="row">
                    <div className="col-md-12">
                      {props.errors.interests && (<p className="input-text-error-msg">Debes seleccionar al menos un interés</p>)}
                    </div>
                    {Interests.map(i => (
                      <div className="col-md-4" key={i}>
                        <div className="checkbox checkbox-theme checkbox-circle">
                          <input
                            id={i}
                            name={i}
                            defaultChecked={props.values.interests.indexOf(i) !== -1}
                            checked={props.values.interests.indexOf(i) !== -1}
                            type="checkbox"
                            onChange={e => this.onChangeInterest(e, props)}
                          />
                          <label htmlFor={i}>
                            {i}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-md-12">
                  <h2 className="heading">Contenido</h2>

                  <div className="row">
                    <div className="col-md-12">
                      <Input name="subject" label="Asunto" />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <WYSIWYG name="content" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="m-b-md m-t-md">
                <button type="submit" className="book-btn">
                  <span className="book-btn-l">
                    <i className="fa fa-save" />
                  </span>
                  <span className="book-btn-r">Enviar</span>
                  <div className="clear" />
                </button>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

MassiveMailerForm.propTypes = {
  onSubmit: PropTypes.func,
};

MassiveMailerForm.defaultProps = {
  onSubmit: () => {},
};

export default MassiveMailerForm;



// WEBPACK FOOTER //
// ./src/containers/Admin/MassiveMailer/form.js